import Image from "next/image";
import { useEffect, useState } from "react";

export interface GifIconProps {
  animationGif: any;
  animationStop: any;

  alt?: string;
  durationMilliSecond: number;
  height: number;
  width: number;
  onAnimationComplete?: () => void;
}

function GifIcon({ animationGif, animationStop: animationSvg, durationMilliSecond, height, width, alt, onAnimationComplete}: GifIconProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [imageSource, setImageSource] = useState<any>();


  useEffect(() => {
    if (isPlaying) {
      setImageSource(animationGif);
      const timeout = setTimeout(() => {
        setIsPlaying(false);
        onAnimationComplete && onAnimationComplete();
      }, durationMilliSecond);
      return () => clearTimeout(timeout);
    } else {
      setImageSource(animationSvg);
    }
  }, [isPlaying]);

  return (
      <span className={"ng-lottie "}>
        {imageSource && <Image
        src={imageSource}
        alt={alt || ""}
        width={width}
        height={height}
        onMouseEnter={() => {
          if (!isPlaying) {
            setIsPlaying(true);
          }
        }}
      />}</span>
  );
}

export default GifIcon;
